import { enumPropsFactoryProvider, objectToEnumMap } from './enum-helper';

/**
 * Направление контейнера
 * @type {Object}
 */
export var CONTAINER_DIRECTION = {
    vertical: 'vertical',
    horizontal: 'horizontal'
};

export var AVAILABLE_DIRECTION = objectToEnumMap(CONTAINER_DIRECTION);

/**
 * Парсера параметра alignment
 * @param  {String} align
 * @param  {String} defaultAlign
 * @return {String}
 */
export default enumPropsFactoryProvider(AVAILABLE_DIRECTION, CONTAINER_DIRECTION.vertical);